import api from './api';
export const paymentService = {
  createOrder:      (booking_id)    => api.post('/payments/create-order', { booking_id }),
  verifyPayment:    (data)          => api.post('/payments/verify', data),
  refundPayment:    (booking_id)    => api.post('/payments/refund', { booking_id }),
  getPaymentReport: (from, to)      => api.get('/payments/report', { params: { from, to } }),
};
